import moment from 'moment';
import { makeAutoObservable } from "mobx"
import ordinal from '../utils/ordinal';

const bday = '06-12';
const bdayAfter = '06-13';

class Countdown {
  seconds = null;
  minutes = null;
  hours = null;
  days = null;
  months = null;
  diff = Math.infinity;
  proper = false;
  nth = false;
  ordinal = false;
  serverNow = null;
  bdayEnd = null;

  constructor() {
    makeAutoObservable(this);
    const now = moment.utc();
    const year = now.year();
    const afterBday = moment.utc(`${year}-${bdayAfter}`);
    if (now.isAfter(afterBday))
      this.setFrom(moment.utc(`${year + 1}-${bday}`));
    else
      this.setFrom(moment.utc(`${year}-${bday}`));
  }

  disableSetFrom(val) {
    this.setFromDisabled = val;
  }

  setProper(val) {
    this.proper = val;
  }

  setFrom(from) {
    if (this.setFromDisabled)
      return console.log('setFrom disabled');
    if (!moment.isMoment(from)) {
      from = moment.unix(from);
    }
    // The birthday recurs every year on 06-12. If the supplied instant (and its
    // 24h birthday window) has already fully passed, roll forward a year at a
    // time so the homepage counts down to the next anniversary instead of going
    // negative. When the backend's DROP_AT points at an upcoming birthday this
    // loop is a no-op.
    const now = moment().add(this.serverDiff || 0, 'seconds');
    while (now.isAfter(from.clone().add(1, 'day'))) {
      from = from.clone().add(1, 'year');
    }
    this.from = from;
    this.nth = from.year() - 2019;
    this.ordinal = ordinal(this.nth);
    this.calculate();
    if (!this.interval)
      this.start();
  }

  setServerDiff(val) {
    this.proper = true;
    this.serverDiff = val;
  }

  setBdayEnd(val) {
    // Ignore a stale window end from the server (e.g. this year's already-passed
    // drop) once `from` has rolled forward to the next birthday.
    if (this.from && val < this.from.unix()) return;
    this.bdayEnd = val;
  }

  // Wallet-connect window: open from the day before the birthday (00:00 UTC)
  // through the end of the birthday day. Lets people connect before midnight to
  // be present for the drop, and keep connecting/claiming on the day itself.
  get connectOpen() {
    if (!this.serverNow || !this.from) return false;
    const start = this.from.unix() - 86400; // day before, 00:00 UTC
    const end = this.bdayEnd ?? this.from.unix() + 86400; // end of birthday day
    return this.serverNow >= start && this.serverNow < end;
  }

  // Drop-socket window: the token drop is a single broadcast at `from` (midnight),
  // so we only need a live WebSocket in the run-up to it. Open 3 hours before the
  // drop and hold for an hour after, to absorb clock skew / a slightly late alarm
  // and make sure the broadcast is actually received. Outside this window there is
  // nothing for the socket to do, so we don't connect.
  get dropWindowOpen() {
    if (!this.serverNow || !this.from) return false;
    const drop = this.from.unix();
    return this.serverNow >= drop - 3 * 3600 && this.serverNow < drop + 3600;
  }

  start() {
    this.interval = setInterval(() => this.calculate(), 1000);
  }

  stop() {
    clearInterval(this.interval);
  }

  calculate() {
    const now = moment().add(this.serverDiff, 'seconds');
    this.serverNow = now.unix();
    this.diff = this.from.diff(now);
    const duration = moment.duration(this.diff);
    this.seconds = duration.seconds();
    this.minutes = duration.minutes();
    this.hours = duration.hours();
    this.days = duration.days();
    this.months = duration.months();
  }
}

export default Countdown;
